import { therapyPlanningAction } from '../../actions/constant';

const { UPDATE_ASSESSMENT_FAILURE, UPDATE_ASSESSMENT_SUCCESS, RESET_UPDATE_ASSESMENT } =
  therapyPlanningAction;

const intitialstate: object = {
  isAssessmentUpdated: false,
  response: null,
};

export const updateAssessmentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_ASSESSMENT_SUCCESS: {
      return {
        ...state,
        isAssessmentUpdated: true,
        response: action.payload,
      };
    }

    case UPDATE_ASSESSMENT_FAILURE:
      return {
        ...state,
        isAssessmentUpdated: false,
        response: action.payload,
      };

    case RESET_UPDATE_ASSESMENT:
      return intitialstate;

    default:
      return state;
  }
};
